
interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
